import Request from "./request";

export const getLocationsList = () => {
  return Request.call({
    url: "/location?per_page=100",
    method: "GET",
  });
};
